"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@mui/styles");

var _Icon = _interopRequireDefault(require("./Icon/Icon"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    circle: {
      width: '3rem',
      height: '3rem',
      borderRadius: '50%',
      backgroundColor: palette.error.main,
      color: palette.common.white
    },
    eye: {
      color: palette.common.white,
      position: 'absolute',
      left: '2.25rem',
      cursor: 'unset'
    }
  };
});

var SlashedEyeCircle = function SlashedEyeCircle() {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.circle
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: classes.eye,
    icon: "eye-slash"
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(SlashedEyeCircle);

exports["default"] = _default;